import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/Styles';
import ListItem2 from 'Components/ComponentLibrary/Components/ListItems/ListItem2';
import ListItemText1 from 'Components/ComponentLibrary/Components/Uncategorized/ListItemText/ListItemText1';
import List1 from 'Components/ComponentLibrary/Components/Lists/List1';
import BasicAlert from 'Components/ComponentLibrary/Atoms/Alerts/Basic';
import EditIcon from '@material-ui/icons/Edit';
import ListItemSecondaryAction
  from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItemSecondaryAction';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import PrimaryCard from 'Components/ComponentLibrary/Molecules/PrimaryCard';
import classNames from 'classnames';

const styles = theme => ({
  root: {},
  listItem: {
    marginTop: theme.spacing(1),
  },
  primaryText: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  avatar: {
    margin: theme.spacing(1, 1, 0, 0),
  },
  emptyText: {
    marginTop: theme.spacing(2),
  },
  secondaryAction: {
    pointerEvents: 'none',
  },
});

const PrimaryCardWithCollection = ({
  className,
  classes,
  onAdd,
  onEdit,
  header,
  title,
  itemCollection,
  getItemPrimaryText,
  getItemSecondaryText,
  emptyListAlertTitle,
  emptyListAlertMessage,
  resource,
}) => {
  return (
    <PrimaryCard
      className={classNames(classes.root, className)}
      onAdd={onAdd}
      header={header}
      title={title}
      resource={resource}
    >
      {(itemCollection.resources().length() > 0) ? (
        <List1>
          {itemCollection.resources().list().map((itemResource) => {
            const isDisabled = !itemResource.link('self');
            return (
              <ListItem2
                key={itemResource.id()}
                className={classes.listItem}
                color={'accentBlue20'}
                disabled={isDisabled}
                button
                onClick={() => {
                  return onEdit(itemResource);
                }}
                test={`primary-card-list-item-${getItemPrimaryText(itemResource)}`}
              >
                <ListItemText1
                  primary={getItemPrimaryText(itemResource)}
                  secondary={getItemSecondaryText(itemResource)}
                />
                {isDisabled ? null : (
                  <ListItemSecondaryAction
                    className={classes.secondaryAction}
                  >
                    <IconButton
                      disabled={isDisabled}
                      icon={EditIcon}
                    />
                  </ListItemSecondaryAction>
                )}
              </ListItem2>
            );
          })}
        </List1>
      ) : (
        <BasicAlert
          className={classes.emptyText}
          severity={'warning'}
          title={emptyListAlertTitle}
          message={emptyListAlertMessage}
        />
      )}
    </PrimaryCard>
  );
};

PrimaryCardWithCollection.defaultProps = {
  className: '',
  resource: null,
  header: null,
  emptyListAlertMessage: '',
};

PrimaryCardWithCollection.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  header: PropTypes.node,
  itemCollection: PropTypes.object.isRequired,
  onAdd: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  getItemPrimaryText: PropTypes.func.isRequired,
  getItemSecondaryText: PropTypes.func.isRequired,
  emptyListAlertTitle: PropTypes.string.isRequired,
  emptyListAlertMessage: PropTypes.string,
  resource: PropTypes.object,
};

export default withStyles(styles)(PrimaryCardWithCollection);
